import { Typography } from "@mui/material";
import { FC } from "react";

type TJobTitleProps = {
  text: string;
};

export const JobFormTitle: FC<TJobTitleProps> = ({ text }) => <Typography variant="sub16Bold">{text}</Typography>;
